import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-boolean-cell',
    templateUrl: './boolean-cell.component.html',
    styleUrls: ['./boolean-cell.component.scss'],
    standalone: false
})
export class BooleanCellComponent implements OnInit {
  displayValue: any;
  value: any;
  colDef: any;
  isEditable: boolean;
  data: any;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);
    const value = reader.getFieldValue(field.systemName);
    this.data = params?.data;
    this.colDef = params?.column?.colDef;
    this.isEditable = this.colDef?.cellRendererParams?.isEditable === true;
    this.value = value;
    const key = value ? 'MANAGEMENT.DATASETS.TRUE' : 'MANAGEMENT.DATASETS.FALSE';
    this.displayValue = !!params.data ? this.translate.instant(key) : params.value;
  }

  onClick(): void {
    this.colDef.cellRendererParams.click(this.data);
  }

}
